import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthSessionService } from '../services/session/auth-session.service';

export const noAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const session = inject(AuthSessionService);

  return session.isAuthenticated() ? router.createUrlTree(['/staff']) : true;
};
